<template>
  <div class="content">
    <a-row>
      <a-col :span="12">
        <a-button :class="type == 'all' ? 'select-btn' : ''"
                  @click="searchClick('all')">{{ $t('Notice.NoticeSeed.all') }}</a-button>
        <a-button :class="type == 'order-info' ? 'select-btn' : ''"
                  @click="searchClick('order-info')">{{ $t('Notice.NoticeSeed.orderNotification') }}</a-button>
        <a-button :class="type == 'comment-info' ? 'select-btn' : ''"
                  @click="searchClick('comment-info')">{{ $t('Notice.NoticeSeed.commentReply') }}</a-button>
      </a-col>
      <a-col :span="12"
             class="headerGroup">
        <a-button type="danger"
                  @click="ButtonFunc.delete">
          <delete-outlined />{{ $t('Notice.NoticeSeed.delete') }}</a-button>
      </a-col>
    </a-row>
    <a-table class="table"
             :data-source="noticeList"
             :row-selection="{ selectedRowKeys: tableSelectionKeys, onChange: tableSelectionOnchange, type: 'checkbox' }"
             :pagination="false"
             row-key="id"
             :scroll="{ y: '600px', x: '100%' }"
             :columns="tableColumns">
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'type'">
          <span v-if="record.type == 0">{{ $t('Notice.NoticeSeed.systemMessage') }}</span>
          <span v-if="record.type == 1">{{ $t('Notice.NoticeSeed.userMessage') }}</span>
        </template>
        <template v-if="column.key === 'content'">
          <div v-if="record.type == 'comment-info'">
            {{ JSON.parse(record.content).content }}
          </div>
        </template>
        <template v-if="column.key === 'createdAt'">
          <div>{{ convertTime(record.createdAt) }}</div>
        </template>
        <template v-if="column.key === 'operation'">
          <div v-if="record.type == 'comment-info'"
               class="detail-btn"
               @click="goToDetail(record)">{{ $t('Notice.NoticeSeed.viewDetails') }}</div>
        </template>
      </template>
    </a-table>
    <a-row>
      <a-col :span="24"
             class="footerPagination">
        <APagination v-model:current="paginationLimit"
                     :total="paginationTotal"
                     :show-size-changer="true"
                     @change="changeNoticePagination" />
      </a-col>
    </a-row>
  </div>
</template>


<script setup lang="ts">
import { APagination } from '@iota-cn/ui-components'
import { message } from 'ant-design-vue'
import { onMounted, reactive, ref, computed } from 'vue'
import { convertTime } from '../plugin'
import { noticeDelete, noticeGetList } from '../service/notice'
import type { NoticeData } from '../service/type'
import { useRouter } from "vue-router"
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const router = useRouter()
const paginationLimit = ref<number>(1)
const paginationTotal = ref<number>(0)
const tableSelectionKeys = ref<string[]>([])
const tableSelectionRows = ref<Array<NoticeData>>([])
const pagesize = ref<number>(10)
// declared code
onMounted(() => {
  const noticeData = sessionStorage.getItem('noticeData') as any
  const data = JSON.parse(noticeData)
  if (data) {
    type.value = data.type
    paginationLimit.value = data.offset
    getNoticeList(data.limit, (data.offset - 1) * data.limit)
  } else {
    getNoticeList()
  }
  sessionStorage.clear()
})
const type = ref<string>('all')
const searchClick = (title: string) => {
  type.value = title
  paginationLimit.value = 1
  const data = {
    limit: 10,
    offset: 0,
    status: '1',
  } as any
  if (type.value != 'all') {
    data.type = type.value
  }
  noticeGetList(data).then(result => {
    noticeList.value = result.rows
    paginationTotal.value = result.total
  })
}
const goToDetail = (record: any) => {
  const comment_id = JSON.parse(record.content).id
  const data = {
    type: type.value,
    offset: paginationLimit.value,
    limit: pagesize.value
  }
  sessionStorage.setItem('noticeData', JSON.stringify(data))
  router.push(`/console/accounts/comment/${comment_id}?from=comment`)
}
// declared static
const noticeList = ref<Array<NoticeData>>([])

const tableColumns = computed(() => [
  { title: t('Notice.NoticeAll.notificationTitle'), dataIndex: "title", key: "title", width: '25%', align: 'center' },
  { title: t('Notice.NoticeAll.notificationMessage'), dataIndex: "content", key: "content", width: '50%', align: 'center' },
  { title: t('Notice.NoticeAll.notificationTime'), dataIndex: "createdAt", key: "createdAt", width: '25%', align: 'center' },
  { title: t('Notice.NoticeAll.operation'), dataIndex: "operation", key: "operation", width: '15%', align: 'center' },
])

// declared Method
const tableSelectionOnchange = (keys: string[], rows: Array<NoticeData>) => {
  tableSelectionKeys.value = keys
  tableSelectionRows.value = rows
}

const changeNoticePagination = (page: number, pageSize: number) => {
  paginationLimit.value = page
  pagesize.value = pageSize
  getNoticeList(pageSize, (page - 1) * pageSize)
}

const getNoticeList = (limit = 10, offset = 0, status = '1') => {
  const data = {
    limit,
    offset,
    status
  } as any
  if (type.value != 'all') {
    data.type = type.value
  }
  noticeGetList(data).then(result => {
    noticeList.value = result.rows
    paginationTotal.value = result.total
  })
}

const ButtonFunc = {
  /** 删除一条消息 */
  delete: () => {
    const noticeIds = tableSelectionRows.value.map(item => item.id)

    noticeDelete(noticeIds.join(',')).then(() => {
      message.success(t('Notice.NoticeSeed.deleteSuccess'))
      getNoticeList()
    })
  },
  /** 删除全部消息 */
  allDelete: () => {
    noticeDelete().then(() => {
      message.success(t('Notice.NoticeSeed.deleteAllSuccess'))
      getNoticeList()
    })
  },
}

</script>


<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;

  .select-btn {
    background-color: #111;
    color: #fff;
  }

  .table {
    width: 100%;
    flex: 1;
    overflow: auto;

    .detail-btn {
      cursor: pointer;
    }

  }

  .headerGroup {
    display: flex;
    justify-content: end;
    margin-bottom: 20px;

    .ant-btn {
      margin: 0 10px 0 0
    }
  }

  .footerPagination {
    display: flex;
    justify-content: end;
  }
}
</style>
